import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { getURlWithoutJPG } from '@ecg-marktplaats/media-util-js-lib';
import ListingVipLink from '@/client/components/ListingsNew/components/ListingVipLink/ListingVipLink';
import priceFormatter from '@/client/utils/formatters/priceFormatter';
import { Image, TextRegular, Title5 } from '@hz-design-system/web-ui';
import { ItemProps } from './types';
import { classNames } from './classNames';

import Classes from './ListingOtherSellerItem.module.scss';

const Item: React.FC<ItemProps> = ({ vipUrl, imageUrl, title, priceInfo, reserved, correlationId, pageLocation }) => {
  const { t } = useI18nContext();

  return (
    <ListingVipLink
      correlationId={correlationId}
      vipUrl={vipUrl}
      className={Classes[classNames.item]}
      pageLocation={pageLocation}
    >
      <div className={Classes[classNames.imageContainer]}>
        <Image
          alt={title || ''}
          src={getURlWithoutJPG(imageUrl)}
          data-src={getURlWithoutJPG(imageUrl)}
          loading="lazy"
          decoding="async"
          aspectRatio="landscape"
        />
      </div>
      <div className={Classes[classNames.titleAndPrice]}>
        <TextRegular strong className={Classes[classNames.itemTitle]}>
          {title}
        </TextRegular>
        <Title5 className={Classes[classNames.itemPrice]}>{t(priceFormatter(priceInfo, reserved), priceInfo)}</Title5>
      </div>
    </ListingVipLink>
  );
};

export default Item;
